import React, { useState } from 'react';
import { formatPostedOnDate } from '../../../common/helpers';
import DOMPurify from 'dompurify';
import { marked } from 'marked';
import { preprocessMarkdown } from '../../../common/helpers';

const SkillsSection = ({ skills }) => {
  const [showAllSkills, setShowAllSkills] = useState(false);
  const skillsArray = Array.isArray(skills) ? skills : [];
  const visibleSkills = showAllSkills ? skillsArray : skillsArray.slice(0, 3);
  const hiddenCount = skillsArray.length - 3;

  return (
    <div className="mt-4">
      <p className="text-xs text-gray-999">Skills & Expertise Required</p>
      <div className="flex flex-wrap gap-2 mt-2 items-center">
        {visibleSkills.map((skill, idx) => (
          <span
            key={`${skill}-${idx}`}
            className="bg-emerald-50 mph-primary text-xs font-semibold px-2.5 py-1 rounded-full"
          >
            {skill}
          </span>
        ))}
        {hiddenCount > 0 && !showAllSkills && (
          <button
            type="button"
            onClick={(e) => {
              e.stopPropagation();
              setShowAllSkills(true);
            }}
            className="text-xs px-2 py-1 rounded-full border border-gray-200 cursor-pointer hover:bg-gray-100"
          >
            +{hiddenCount} more
          </button>
        )}
        {showAllSkills && hiddenCount > 0 && (
          <button
            type="button"
            onClick={(e) => {
              e.stopPropagation();
              setShowAllSkills(false);
            }}
            className="text-xs px-2 py-1 rounded-full border border-gray-200 cursor-pointer hover:bg-gray-100"
          >
            Show less
          </button>
        )}
      </div>
    </div>
  );
};

const JobDetailsPanel = (jobDetails) => {
  const job = jobDetails.jobDetails;
  return (
    <aside className="text-left bg-white p-4 rounded-2xl shadow-sm h-full overflow-y-auto flex flex-col">
      <h3 className="text-xl font-semibold mph-primary">Job details</h3>
      <div className="border-b border-gray-100 my-4"></div>

      <div className="font-semibold text-lg text-gray-333">{job?.title}</div>
      <p className="text-sm text-gray-999">{job.company_name}</p>

      <div className="gap-4 text-xs mt-4">
        <div className="grid grid-cols-2 gap-y-2 gap-x-4">
          <div className="text-xs text-gray-999">Job ID</div>
          <div className="font-semibold text-gray-333">{job.mph_jobid ? job.mph_jobid : '-'}</div>
          <div className="text-xs text-gray-999">Posted on</div>
          <div className="font-semibold text-gray-333">{job.job_opening_date ? formatPostedOnDate(job.job_opening_date) : '-'}</div>
          <div className="text-xs text-gray-999">Location</div>
          <div className="font-semibold text-gray-333">{job.city ? job.city : '-'}</div>
          <div className="text-xs text-gray-999">Vacancies</div>
          <div className="font-semibold text-gray-333">{job.vacancy ? job.vacancy : '-'}</div>
          <div className="text-xs text-gray-999">Application Deadline</div>
          <div className="font-semibold text-gray-333">{job.application_deadline_datetime ? formatPostedOnDate(job.application_deadline_datetime) : '-'}</div>
        </div>
      </div>

      {/* <SkillsSection skills={job.skills_required} /> */}

      {/* === Job Description === */}
      <div className="mph-light mt-6 rounded-lg p-5 border-l-4 border-green-700 space-y-4">

  {/* Responsibilities & Skills */}
  {job?.capabilities?.capabilities?.length > 0 ? (
    <div>
      <h3 className="font-semibold text-xs text-green-800 mb-2">
        Responsibilities & Skills
      </h3>
      <ul className="list-disc list-inside text-xs text-gray-700 space-y-1">
        {job.capabilities.capabilities.map((item, index) => (
          <li key={index}>{item}</li>
        ))}
      </ul>
    </div>
  ) : (
    <p className="text-gray-500 text-xs italic">
      No Responsibilities and Skills data available.
    </p>
  )}

  {/* Experience Required */}
  {job?.experience_required?.length > 0 ? (
    <div>
      <h3 className="font-semibold text-xs text-green-800 mb-2">
        Experience Required
      </h3>
      <ul className="list-disc list-inside text-xs text-gray-700 space-y-1">
        {job.experience_required.map((item, index) => (
          <li key={index}>{item}</li>
        ))}
      </ul>
    </div>
  ) : (
    <p className="text-gray-500 text-xs italic">
      No Experience data available.
    </p>
  )}

  {/* Education Requirements */}
  {job?.education_requirements?.length > 0 ? (
    <div>
      <h3 className="font-semibold text-xs text-green-800 mb-2">
        Education Requirements
      </h3>
      <ul className="list-disc list-inside text-xs text-gray-700 space-y-1">
        {job.education_requirements.map((item, index) => (
          <li key={index}>{item}</li>
        ))}
      </ul>
    </div>
  ) : (
    <p className="text-gray-500 text-xs italic">
      No Education data available.
    </p>
  )}

</div>
    </aside>
  );
};

export default JobDetailsPanel;